<template>
  <div style="position:fixed;width:calc(100vw - 110px);height:calc(100vh - 50px);background:#000000;z-index:2;color:#ffffff;">
    <!--背景视频-->
    <video v-if="backgroundVideoShow" style="position:absolute;width:100%;height:100%;object-fit:cover;" autoplay loop muted>
      <source :src="videoList[currChooseItemNum]" type="video/mp4" />
    </video>

    <div v-if="currChooseItemNum === 0" style="position:absolute;top:76px;left:83px;">
      <p style="font-size:36px;font-weight:bold;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">智能旅游路线规划工具</p>
      <!--试用按钮-->
      <div @click="intoTravelPlanPlugin" style="width:139px;height:52px;background:rgb(255, 79, 120);border-radius:12px;margin-top:80px;cursor:pointer;text-align:center;">
        <p style="line-height:52px;font-size:20px;">立即试用</p>
      </div>
    </div>
    <div v-if="currChooseItemNum === 1" style="position:absolute;top:76px;left:83px;">
      <p style="font-size:36px;font-weight:bold;text-shadow: rgba(0, 0, 0, 0.9) 0px 2px 4px;">您希望吉林一号·共生地球遥感工作台中增加哪些AI工具？</p>

      <!--输入反馈内容-->
      <div v-if="!feedbackFinish" id="feedbackTextFieldParent" style="margin-top:80px;overflow:hidden;">
        <v-text-field v-model="feedbackContent" id="feedbackTextField" autocomplete="off" outlined placeholder="" hide-details color="#ffffff"
                      style="width:603px;background:rgba(255, 255, 255, 0.5);border-radius:30px;float:left;">
          <template v-slot:append>
            <p :style="{'color':feedbackContent.length>100 ? '#D43030' : '#ffffff'}" style="font-size:14px;" class="mt-1">{{feedbackContent.length}}/100</p>
          </template>
        </v-text-field>
        <div @click="feedbackOK" :style="{'background':feedbackContent.length > 100 || feedbackContent.length === 0 ? '#F58BA4' : 'rgb(255, 79, 120)'}"
             style="width:139px;height:52px;background:rgb(255, 79, 120);border-radius:12px;margin-top:2px;margin-left:48px;cursor:pointer;text-align:center;float:left;">
          <p style="line-height:52px;font-size:20px;">立即反馈</p>
        </div>
      </div>

      <!--感谢反馈-->
      <div v-if="feedbackFinish" style="margin-top:96px;font-size:20px;overflow:hidden;">
        <p style="color:#43CF7C;float:left">
          <span class="iconfontFamily">&#xe6b7;</span>
          感谢您的反馈！
        </p>
        <p @click="feedbackOneMore" style="margin-left:36px;color:#FF4F78;float:left;cursor:pointer;">再次反馈</p>
      </div>


    </div>

    <!--切换页面-->
    <div style="position:absolute;left:50%;bottom:38px;transform:translate(-50%);width:469px;height:100px;display:flex;">
      <div @click="changeChooseItem(0)"
           :style="{'background':currChooseItemNum === 0 ? 'rgba(255, 79, 120, 0.75)' : 'rgba(0, 0, 0, 0.75)'}"
           style="width:220px;height:100%;border-radius:15px;padding-left:18px;backdrop-filter:blur(10px);cursor:pointer;display:flex;flex-direction:column;justify-content:center;">
        <p style="font-size:18px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">吉林一号·星旅</p>
        <p style="margin-top:12px;font-size:16px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">智能生成旅游路线规划</p>
      </div>
      <div @click="changeChooseItem(1)"
           :style="{'background':currChooseItemNum === 1 ? 'rgba(255, 79, 120, 0.75)' : 'rgba(0, 0, 0, 0.75)'}"
           style="width:220px;height:100%;border-radius:15px;margin-left:29px;padding-left:18px;backdrop-filter:blur(10px);cursor:pointer;display:flex;flex-direction:column;justify-content:center;">
        <p style="font-size:18px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">建议收集</p>
        <p style="margin-top:12px;font-size:16px;text-shadow:0px 2px 4px rgba(0, 0, 0, 0.9);">您希望增加哪些功能？</p>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "MainAI",
  data(){
    return{
      backgroundVideoShow:true,
      videoList:[
        "https://market.obs.cn-north-4.myhuaweicloud.com:443/202409100920000109396.mp4",
        "https://market.obs.cn-north-4.myhuaweicloud.com:443/202409111134000045853.mp4"
      ],

      //当前选中栏
      currChooseItemNum:0,

      //反馈相关
      feedbackContent:"",
      feedbackFinish:false,


    }

  },
  methods:{
    //切换选中页面
    changeChooseItem(videoNum){
      this.backgroundVideoShow = false;
      if(videoNum === 1){
        this.getFeedbackStatus()
      }
      this.currChooseItemNum = videoNum
      setTimeout(()=>{
        this.backgroundVideoShow = true;
      },0)

    },

    //打开插件项目
    intoTravelPlanPlugin(){
      window.open("https://earth.jl1.cn/plugin/travelPlanHome")
    },


    //反馈
    feedbackOK(){
      if(this.feedbackContent.length <= 100 && this.feedbackContent.length !== 0){
        this.$axios({
          method:"post",
          url:"/pluginApi/p-feedback/addPFeedback",
          params:{
            feedbackContent:this.feedbackContent
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          console.log(resultData)
          if(resultData.status === 200){
            this.feedbackFinish = true;
          }
        }).catch((err)=>{
          console.log(err);
        });
      }

    },

    //再次反馈
    feedbackOneMore(){
      this.feedbackContent = "";
      this.feedbackFinish = false;
    },

    //获取是否已经反馈过
    getFeedbackStatus(){
      this.$axios({
        method:"get",
        url:"/pluginApi/p-feedback/getFeedbackSubmitted",
      }).then((resultData)=>{
        resultData = resultData.data;
        console.log(resultData)
        if(resultData.status === 200){
          this.feedbackFinish = resultData.data;
        }
      }).catch((err)=>{
        console.log(err);
      });
    }



  }


}
</script>

<style>
#feedbackTextField{
  color:#000000;
  font-size: 18px;
  caret-color:#000000;
}

#feedbackTextFieldParent .v-input__slot{
  padding:0 24px;
}
#feedbackTextFieldParent fieldset{
  border-width:0;
}
#feedbackTextFieldParent .v-input--is-focused fieldset{
  border:1px solid rgba(255, 79, 120, 0.75) !important;
}

</style>